import { render, staticRenderFns } from "./DemandList.vue?vue&type=template&id=411da275&scoped=true"
import script from "./DemandList.vue?vue&type=script&lang=js"
export * from "./DemandList.vue?vue&type=script&lang=js"
import style0 from "./DemandList.vue?vue&type=style&index=0&id=411da275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411da275",
  null
  
)

export default component.exports